<template>
  <div class="relative bg-white pt-16 pb-16">
    <div class="px-4 md:px-10 mx-auto w-full">
      <div class="flex flex-wrap mt-6">
        <div class="w-full px-4">
          <div class="relative flex flex-col min-w-0 break-words w-full mb-6 shadow-lg rounded bg-white">
            <div class="rounded-t mb-0 px-6 py-3 border-0">
              <div class="flex flex-wrap items-center">
                <div class="relative w-full px-4 max-w-full flex-grow flex-1">
                  <h3 class="font-semibold text-base text-blueGray-700">商品管理</h3>
                </div>
                <div class="relative w-full px-4 max-w-full flex-grow flex-1 text-right">
                  <button
                    @click="editGoods()"
                    class="bg-emerald-500 hover:bg-emerald-600 text-white font-bold py-2 px-4 rounded text-sm"
                    type="button"
                  >
                    <i class="fas fa-plus mr-1"></i>
                    新增商品
                  </button>
                </div>
              </div>
            </div>
            <div class="block w-full px-6 pb-6">
    <el-table style="margin-top: 16px;" :data="list" border>
      <el-table-column prop="name" label="名称"></el-table-column>
      <el-table-column label="商品瀑布流图片">
        <template #default="scope">
          <img style="width: 200px;height: 200px;" :src="getDisplayImageUrl(scope.row.cover || '')" />
        </template>
      </el-table-column>
      <el-table-column label="商品头图">
        <template #default="scope">
          <img style="width: 200px;height: 200px;" :src="getDisplayImageUrl(scope.row.head_url)" />
        </template>
      </el-table-column>

      <el-table-column label="数量">
        <template #default="scope">
          <p>{{ scope.row.count || 1 }}</p>
        </template>
      </el-table-column>
      <el-table-column label="活动说明">
        <template #default="scope">
          <div class="scroll activity-container">
            <div v-for="(item, index) in scope.row.desc" :key="index">
              <template v-if="item.type == 'text'">
                <div
                  :style="{ fontSize: `${item.font_size ? item.font_size / 2 : 14}px`, color: item.color || '#000', textAlign: item.text_align || 'left' }">
                  {{ item.value }}</div>
              </template>
              <template v-else-if="item.type == 'img_hd' || item.type == 'img' || item.type == 'file'">
                <img :style="{ width: '100%' }" :src="getDisplayImageUrl(item.value)" />
              </template>
            </div>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="操作">
        <template #default="scope">
          <el-button @click="editGoods(scope.row)" type="text">编辑</el-button>
          <el-button @click="deleteGoods(scope.row._id)" type="text">删除</el-button>
        </template>
      </el-table-column>
    </el-table>

    <el-pagination style="margin-top: 16px; text-align: right" @size-change="handleSizeChange"
      @current-change="handleCurrentChange" :current-page="page" :page-sizes="[20, 50, 100]"
      :page-size="page_size" layout="total, sizes, prev, pager, next, jumper" :total="total"></el-pagination>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 展示弹框 -->
    <el-dialog :title="editItem._id == undefined ? '新增' : '编辑'" v-model="formOpen">
      <el-form label-position="right" label-width="160px" :model="editItem" :rules="formRules">
        <el-form-item label="商品名称" prop="name">
          <el-input v-model="editItem.name" placeholder="请输入商品名称" />
        </el-form-item>
        <el-form-item label="商品首页瀑布流图片" required>
          <el-upload class="avatar-uploader" drag :show-file-list="false" :on-success="handleCoverSuccess"
            :before-upload="coverBeforeUpload" :action="uploadImgUrl" :headers="uploadHeaders">
            <img v-if="editItem.cover" :src="editItem.cover" class="avatar" />
            <div v-else class="avatar-upload-content">
              <div class="avatar-upload-title">拖拽图片到这里，或点击上传</div>
              <div class="avatar-upload-desc">首页瀑布流图尺寸：750 * 1000</div>
            </div>
          </el-upload>
        </el-form-item>
        <el-form-item label="商品详情头图" required>
          <el-upload class="avatar-uploader" drag :show-file-list="false" :on-success="handleHeadSuccess"
            :before-upload="headBeforeUpload" :action="uploadImgUrl" :headers="uploadHeaders">
            <img v-if="editItem.head_url" :src="editItem.head_url" class="avatar" />
            <div v-else class="avatar-upload-content">
              <div class="avatar-upload-title">拖拽图片到这里，或点击上传</div>
              <div class="avatar-upload-desc">商品详情头图尺寸：900 * 900</div>
            </div>
          </el-upload>
        </el-form-item>

        <el-form-item label="商品数量" required>
          <el-input-number style="text-align: left;" v-model="editItem.count" :min="1"></el-input-number>
        </el-form-item>
        <el-form-item label="活动说明">

          <div class="rule-container scroll" @click="openRule">
            <div style="font-size: 14px;color: #999;" v-if="editItem.desc.length == 0">请输入活动说明，支持文本，图片</div>
            <template v-else>
              <div v-for="(item, index) in editItem.desc" :key="index"
                :style="{ marginTop: index > 0 ? '10px' : '0px' }">
                <template v-if="item.type == 'text'">
                  <div :style="{ fontSize: `${item.font_size / 2}px`, color: item.color, textAlign: item.text_align }">
                    {{
                      item.value }}</div>
                </template>
                <template v-else-if="item.type == 'img_hd' || item.type == 'img' || item.type == 'file'">
                  <img :style="{ width: '100%' }" :src="item.value" />
                </template>
              </div>
            </template>
          </div>
        </el-form-item>
      </el-form>
      <template #footer><span style="display: flex;align-items: center;justify-content: flex-end;">
        <el-button @click="formOpen = false">取消</el-button>
        <el-button @click="handleItem" type="primary">确定</el-button>
      </span></template>
    </el-dialog>
    <!-- 展示活动说明编辑弹窗 -->
    <el-dialog :close-on-click-modal="false" title="活动说明" v-model="ruleOpen">
      <div>
        <div style="font-size: 12px;color: #999;">点击下方说明类型进行添加</div>
        <div class="menu-list">
          <div class="menu-item" @click="addRule('text')" style="margin-right: 10px;">
            <img style="width: 20px;height: 20px;"
              src="https://cdn-xcx-qunsou.weiyoubot.cn/material/20230708/57437ca29b64bb98d698da5464700d8a.svg" />
            <div class="menu-text">文本</div>
          </div>
          <el-upload class="rule-image-uploader" drag accept="image/*" :show-file-list="false"
            :on-success="handleRulePicSuccess" :before-upload="beforeAvatarUpload"
            :action="uploadImgUrl" :headers="uploadHeaders">
            <div class="rule-image-upload-content">
              <img style="width: 20px;height: 20px;"
                src="https://cdn-xcx-qunsou.weiyoubot.cn/material/20230708/607018a60720c0f235451c11ae52d014.svg" />
              <div class="menu-text">拖拽图片到这里，或点击上传</div>
              <div class="rule-image-upload-hint">单张图片不超过 5MB</div>
            </div>
          </el-upload>
        </div>
        <div class="scroll"
          style="max-height: 50vh;min-height: 200px;overflow: auto;margin-top: 10px;padding-bottom: 20px;">
          <div v-for="(item, index) in rules" :key="index">
            <div style="margin-top: 10px;border: 1px solid #eee;">
              <div
                style="display: flex; align-items: center; justify-content: space-between; height: 40px;padding: 0 16px; border-bottom: 1px solid #eee;">
                <div style="display: flex;align-items: center;">
                  <!-- <div style="display: flex;align-items: center;" v-if="item.type == 'text'">
                    <el-dropdown @command="handleSelectFont($event, index)">
                      <div style="display: flex;align-items: center;cursor: pointer;">
                        <div>{{ item.font_size }}</div>
                        <img style="width: 14px;height: 14px; margin-left: 4px;"
                          src="https://cdn-xcx-qunsou.weiyoubot.cn/material/20230825/2ba7523788fd6930df32d6ad44b688ea.png" />
                      </div>
                      <el-dropdown-menu slot="dropdown">
                        <el-dropdown-item v-for="font in fontItems" :key="font" :command="font">{{ font
                          }}</el-dropdown-item>
                      </el-dropdown-menu>
                    </el-dropdown>

                    <el-dropdown style="margin-left: 24px;" @command="handleSelectColor($event, index)">
                      <div style="display: flex;align-items: center;cursor: pointer;">
                        <div :style="{ width: '14px', height: '14px', backgroundColor: item.color }"></div>
                        <img style="width: 14px;height: 14px; margin-left: 4px;"
                          src="https://cdn-xcx-qunsou.weiyoubot.cn/material/20230825/2ba7523788fd6930df32d6ad44b688ea.png" />
                      </div>
                      <el-dropdown-menu slot="dropdown">
                        <el-dropdown-item v-for="color in colorItems" :key="color" :command="color">
                          <div
                            style="width: 40px;height: 40px;display: flex;justify-content: center;align-items: center;">
                            <div :style="{ width: '40px', height: '20px', backgroundColor: color }"></div>
                          </div>
                        </el-dropdown-item>
                      </el-dropdown-menu>
                    </el-dropdown>

                    <el-dropdown style="margin-left: 24px;" @command="handleSelectAlign($event, index)">
                      <div style="display: flex;align-items: center;cursor: pointer;">
                        <img style="width: 14px;height: 14px;" :src="getAlignIcon(item.text_align)" />
                        <img style="width: 14px;height: 14px; margin-left: 4px;"
                          src="https://cdn-xcx-qunsou.weiyoubot.cn/material/20230825/2ba7523788fd6930df32d6ad44b688ea.png" />
                      </div>
                      <el-dropdown-menu slot="dropdown">
                        <el-dropdown-item v-for="align in alignItems" :key="align.key" :command="align.key">
                          <img style="width: 14px;height: 14px;" :src="align.icon" />
                        </el-dropdown-item>
                      </el-dropdown-menu>
                    </el-dropdown>
                  </div> -->
                </div>
                <div style="display: flex;align-items: center;">
                  <img v-if="index < rules.length - 1" @click="handleSort('toBottom', index)"
                    style="width: 14px;height: 14px;margin-left: 16px;cursor: pointer;"
                    src="https://cdn-xcx-qunsou.weiyoubot.cn/material/20230825/98232544c5602f6b8c59eb94ab8350d6.png" />
                  <img v-if="index > 0" @click="handleSort('toTop', index)"
                    style="width: 14px;height: 14px;margin-left: 16px;cursor: pointer;"
                    src="https://cdn-xcx-qunsou.weiyoubot.cn/material/20230825/03600b21dda30d93815fd745740ba333.png" />
                  <img @click="deleteRule(index)" style="width: 14px;height: 14px;margin-left: 16px;cursor: pointer;"
                    src="https://cdn-xcx-qunsou.weiyoubot.cn/material/20230825/25f11bbade4aff6952281c9a5555d77c.png" />
                </div>
              </div>
              <template v-if="item.type == 'text'">
                <textarea placeholder="请输入活动说明"
                  :style="{ resize: 'none', height: '120px', border: 'none', width: '100%', outline: 'none', padding: '10px', color: item.color || '#000', fontSize: `${item.font_size ? item.font_size / 2 : 14}px`, textAlign: item.text_align || 'left' }"
                  :value="item.value" @input="onInput($event, index)"></textarea>
              </template>
              <template v-if="item.type == 'img_hd' || item.type == 'img' || item.type == 'file'">
                <img style="width: 100%;" :src="item.value" />
              </template>

            </div>
          </div>
        </div>
      </div>
      <template #footer><span style="display: flex;align-items: center;justify-content: flex-end;">
        <el-button @click="ruleOpen = false">取消</el-button>
        <el-button @click="saveRules" type="primary">确定</el-button>
      </span></template>
    </el-dialog>
  </div>
</template>

<script>


export default {
  data() {
    return {
      page: 1,
      page_size: 20,
      total: 0,
      list: [],
      uploadImgUrl: this.$uploadImageUrl,
      uploadHeaders: this.$getUploadHeaders(),

      formOpen: false,
      ruleOpen: false,
      editItem: {
        name: '',
        count: 1,
        head_url: '',
        index_url: '',
        cover:'',
        desc: []
      },
      rules: [],
      formRules: {
        name: [
          { required: true, message: '请输入商品名称', trigger: 'blur' }
        ]
      },
      fontItems: [26, 30, 32, 34, 36, 40, 48, 60],
      colorItems: ['#000000', '#888888', '#e60f15', '#ff990f', '#ffff11', '#158a13', '#1365cc', '#9932ff'],
      alignItems: [
        {
          key: 'left',
          icon: 'https://cdn-xcx-qunsou.weiyoubot.cn/material/20230925/477781c593ab28180090bd125a960b3d.png'
        },
        {
          key: 'right',
          icon: 'https://cdn-xcx-qunsou.weiyoubot.cn/material/20230925/bc23f92fbbe18f63f8ee1d6e9224f814.png'
        },
        {
          key: 'center',
          icon: 'https://cdn-xcx-qunsou.weiyoubot.cn/material/20230925/8aac45ab52782f9b07df4744e1048b1c.png'
        },
        {
          key: 'justify',
          icon: 'https://cdn-xcx-qunsou.weiyoubot.cn/material/20230925/d7da32408d88ee8d1c1f71eda5eb2788.png'
        }
      ]
    };
  },
  mounted() {
    this.queryData();
  },
  methods: {
    queryData() {
      this.$$getDailyGoodsList({
        page: this.page,
        page_size: this.page_size
      }, (res) => {
        if (res.sta === 0) {
          const { count, list } = res.data
          this.list = list
          this.total = count
        } else {
          this.$message.error(res.msg);
        }
      }, () => {
        this.$message.error('请求数据失败')
      })
    },

    handleSizeChange(val) {
      this.page_size = val
      this.queryData()
    },
    handleCurrentChange(val) {
      this.page = val
      this.queryData()
    },

    getAlignIcon(text_align) {
      return this.alignItems.find(obj => obj.key == text_align).icon
    },
    getDisplayImageUrl(url) {
      if (!url) {
        return ''
      }

      const lowerUrl = url.toLowerCase().split('?')[0]
      if (lowerUrl.endsWith('.svg')) {
        return url
      }

      const suffix = 'imageMogr2/thumbnail/240x'
      return `${url}${url.includes('?') ? '&' : '?'}${suffix}`
    },
    editGoods(item = null) {
      if (item == null) {
        this.editItem = {
          name: '',
          count: 1,
          head_url: '',
          cover:'',
          index_url: '',
          desc: [
            {
              type: 'text',
              value: '中奖的锦鲤，请及时联系我们兑奖。',
            },
            {
              type: 'text',
              value: '兑奖时效：开奖后24小时内，逾期未领取视为自愿放弃哦。',
            },
            {
              type: 'text',
              value: '请关注抽奖工具小程序首页活动，你可能就是下一个锦鲤！',
            }
          ]
        }
      } else {
        if (!item.count) {
          item.count = 1
        }
        if (!item.index_url) {
          item.index_url = ''
        }
        this.editItem = JSON.parse(JSON.stringify(item))
      }
      this.formOpen = true
    },
    deleteGoods(id) {
      this.$confirm('是否确定删除该商品', '提示', {
        cancelButtonText: '取消',
        confirmButtonText: '确定',
        type: 'warning'
      }).then(() => {
        this.$$deleteDailyGoods({
          data: {
            id
          }
        }, (res) => {
          if (res.sta === 0) {
            this.queryData()
          } else {
            this.$message.error(res.msg);
          }
        }, () => { })
      })
    },
    handleItem() {
      if (!this.editItem.name) {
        return this.$message.error('请输入商品名称')
      }
      if (!this.editItem.head_url) {
        return this.$message.error('请输入商品详情头图')
      }
      if(!this.editItem.cover){
        return this.$message.error('请上传商品瀑布流图片')
      }
      if (this.editItem._id) {
        this.$$updateDailyGoods({
          id: this.editItem._id,
          name: this.editItem.name,
          count: this.editItem.count,
          head_url: this.editItem.head_url,
          cover:this.editItem.cover,
          desc: this.editItem.desc
        }, (res) => {
          if (res.sta === 0) {
            this.formOpen = false
            this.queryData()
          } else {
            this.$message.error(res.msg);
          }
        }, () => {
          this.$message.error('请求数据失败')
        })
      } else {
        this.$$saveDailyGoods(this.editItem, (res) => {
          if (res.sta === 0) {
            this.formOpen = false
            this.queryData()
          } else {
            this.$message.error(res.msg);
          }
        }, () => {
          this.$message.error('请求数据失败')
        })
      }
    },
    openRule() {
      if (this.editItem.desc.length == 0) {
        this.rules = [
          {
            // font_size: 26,
            // text_align: 'left',
            // color: '#000000',
            type: 'text',
            value: ''
          }
        ]
      } else {
        this.rules = JSON.parse(JSON.stringify(this.editItem.desc))
      }
      this.ruleOpen = true
    },
    handleSelectFont(command, index) {
      this.rules[index].font_size = command
    },
    handleSelectColor(command, index) {
      this.rules[index].color = command
    },
    handleSelectAlign(command, index) {
      this.rules[index].text_align = command
    },
    onInput(e, index) {
      this.rules[index].value = e.target.value
    },

    handleRulePicSuccess(res) {
      this.rules.push({
        type: 'img_hd',
        value: res.data.url
      })
    },

    addRule(type) {
      if (type == 'text') {
        this.rules.push({
          // font_size: 26,
          // text_align: 'left',
          // color: '#000000',
          type: 'text',
          value: ''
        })
      }

    },
    saveRules() {
      for (const item of this.rules) {
        if (item.type == 'text' && !item.value.trim()) {
          this.$message.error('请输入文本内容')
          return
        }
      }
      if (!this.editItem.name) {
        return this.$message.error('请输入商品名称')
      }
      if (!this.editItem.count) {
        return this.$message.error('请输入奖品数量')
      }
      this.editItem.desc = JSON.parse(JSON.stringify(this.rules))
      this.ruleOpen = false
    },
    deleteRule(index) {
      this.rules.splice(index, 1)
    },
    handleSort(type, index) {
      if (type == 'toTop') {
        let newRules = this.reorder(this.rules, index, index - 1)
        this.rules = newRules
      } else if (type == 'toBottom') {
        let newRules = this.reorder(this.rules, index, index + 1)
        this.rules = newRules
      }
    },
    handleHeadSuccess(res) {
      this.editItem.head_url = res.data.url
      this.$forceUpdate()
    },
    handleIndexSuccess(res) {
      this.editItem.index_url = res.data.url
      this.$forceUpdate()
    },
    handleCoverSuccess(res){
      this.editItem.cover = res.data.url
      this.$forceUpdate()
    },
    beforeAvatarUpload(file) {
      if (!file.type.startsWith('image/')) {
        this.$message.error('请上传图片文件')
        return false
      }
      if (file.size / 1024 / 1024 > 5) {
        this.$message.error('图片大小不能超过5M')
        return false
      }
      return true
    },

    reorder(list, startIndex, endIndex) {
      const result = Array.from(list);
      const [removed] = result.splice(startIndex, 1);
      result.splice(endIndex, 0, removed);
      return result;
    },

    headBeforeUpload(file) {
      return new Promise((resolve, reject) => {
        if (file.size > 5 * 1024 * 1024) {
          this.$message.error('图片大小不能超过5M')
          reject()
        } else {
          const img = new Image();
          const url = URL.createObjectURL(file);
          img.onload = () => {
            // 释放对象 URL
            URL.revokeObjectURL(url);
            if (img.width == img.height) {
              resolve()
            } else {
              this.$message.error('商品详情头图需要上传1:1的图片')
              reject()
            }
          };

          img.onerror = () => {
            URL.revokeObjectURL(url);
            // reject(new Error("Failed to load image"));
            reject()
          };
          img.src = url;
        }
      });
    },
    coverBeforeUpload(file){
      return new Promise((resolve, reject) => {
        if (file.size > 5 * 1024 * 1024) {
          this.$message.error('图片大小不能超过5M')
          reject()
        } else {
          const img = new Image();
          const url = URL.createObjectURL(file);
          img.onload = () => {
            // 释放对象 URL
            URL.revokeObjectURL(url);
            if (img.width / img.height == 3 / 4) {
              resolve()
            } else {
              this.$message.error('瀑布流需要上传3:4的图片')
              reject()
            }
          };
          img.onerror = () => {
            URL.revokeObjectURL(url);
            // reject(new Error("Failed to load image"));
            reject()
          };
          img.src = url;
        }
      });
    }
  },

};
</script>

<style scoped>
.dialog-container {
  padding-top: 0px;
}

.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader .el-upload:hover {
  border-color: #409EFF;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}

.avatar {
  width: 178px;
  height: 178px;
  display: block;
}

.avatar-upload-content {
  width: 178px;
  height: 178px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 16px;
  text-align: center;
}

.avatar-upload-title {
  font-size: 13px;
  line-height: 1.4;
  font-weight: 600;
  color: #374151;
}

.avatar-upload-desc {
  font-size: 12px;
  line-height: 1.4;
  color: #6b7280;
}

.activity-container {
  max-height: 200px;
  overflow-y: auto;
}

.rule-container {
  padding: 10px;
  border-radius: 4px;
  cursor: pointer;
  border: 1px solid #d9d9d9;
  max-height: 400px;
  min-height: 200px;
  overflow-y: scroll;
}

.scroll {
  -ms-overflow-style: none;
  overflow: -moz-scrollbars-none;
  scrollbar-width: none;
}

.scroll::-webkit-scrollbar {
  display: none;
}

.menu-list {
  display: flex;
  align-items: center;
  margin-top: 10px;
}

.menu-item {
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px solid #999;
  color: #999;
  border-radius: 4px;
  padding: 4px;
  cursor: pointer;
}

.menu-text {
  font-size: 14px;
  line-height: 14px;
}

.rule-image-uploader :deep(.el-upload-dragger) {
  width: 220px;
  height: auto;
  min-height: 84px;
  padding: 8px;
}

.rule-image-upload-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 5px;
  color: #666;
}

.rule-image-upload-hint {
  font-size: 12px;
  line-height: 16px;
  color: #999;
}
</style>
